<template>
    <v-simple-table dense>
        <thead>
        <tr>
            <th>Severity</th>
            <th>Long window</th>
            <th>Short window</th>
            <th>Burn rate threshold</th>
            <th>Monthly error budget consumed</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="r in rules">
            <td class="text-no-wrap">
                <Led :status="r.s" />{{r.s}}
            </td>
            <td class="text-no-wrap">{{r.lw}}</td>
            <td class="text-no-wrap">{{r.sw}}</td>
            <td>{{r.th}}</td>
            <td>
                <div class="text-no-wrap">{{r.c}}</div>
                <div class="text-no-wrap grey--text">≤ {{r.h}} to exhaustion</div>
            </td>
        </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import Led from "@coroot/coroot/src/components/Led";

export default {
    components: {Led},
    computed: {
        rules() {
            return [
                {s: 'critical', lw: '1 hour', sw: '5 minutes', th: 14.4, c: '2%', h: '50 hours'},
                {s: 'critical', lw: '6 hours', sw: '30 minutes', th: 6, c: '5%', h: '5 days'},
                {s: 'warning', lw: '24 hours', sw: '2 hours', th: 3, c: '10%', h: '10 days'},
            ];
        },
    }
}
</script>

<style scoped>
* >>> td, * >>> th {
    font-family: "Roboto", sans-serif;
}
</style>